import React, { useEffect, useState } from 'react'
import {
  Drawer,
  IconButton,
  Tab,
  Tabs,
  Typography,
  makeStyles,
  withStyles
} from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import AsterTitleTypography from 'asterX-UI/Typography/AsterTitleTypography'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import { SalesService } from 'lib/api'
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator
} from '@material-ui/lab'
import PersonIcon from '@material-ui/icons/Person'
import moment from 'moment/moment'
import HumanizeDuration from 'humanize-duration'
import { useResErrors } from 'hooks'
import { PRIMARY_COLORS } from 'asterX-UI'

const useStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8
  },
  drawerPaper: {
    width: '550px'
  },
  closeButton: {
    color: theme.palette.grey[500]
  },
  wlViewTabs: {
    '& .Mui-selected': {
      color: PRIMARY_COLORS[700]
    },
    '& .MuiTabs-indicator': {
      backgroundColor: PRIMARY_COLORS[700]
    }
  }
}))

const DialogTitleCustom = withStyles()(props => {
  const classes = useStyles()

  const { children, onClose, ...other } = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onClose}
      >
        <ChevronLeftIcon />
      </IconButton>{' '}
      <AsterTitleTypography label={children} />
    </MuiDialogTitle>
  )
})

const StatusLine = ({ statusTrackList }) => {
  const renderDuration = (startDate, endDate, language = 'ru') => {
    const start = moment(startDate)
    const end = moment(endDate)
    if (!start.isValid() || !end.isValid()) {
      return 'Неправильная дата'
    }

    return HumanizeDuration(end.diff(start, 'ms'), {
      language: language,
      units: ['d', 'h', 'm'],
      round: true,
      conjunction: '',
      largest: 2
    })
  }

  const renderCurrentDuration = (startDate, language = 'ru') => {
    const start = moment(startDate)
    const end = moment(new Date())
    if (!start.isValid()) {
      return 'Неправильная дата'
    }

    return HumanizeDuration(end.diff(start, 'ms'), {
      language: language,
      units: ['d', 'h', 'm'],
      round: true,
      conjunction: '',
      largest: 2
    })
  }

  return (
    <Timeline align="right">
      {statusTrackList ? (
        statusTrackList?.map((status, index) => (
          <TimelineItem key={status.id}>
            <TimelineOppositeContent
              style={{
                padding: '6px 0 6px 16px'
              }}
            >
              <Typography variant="body2" color="textSecondary">
                <b>{moment(status?.startDate).format('DD.MM.yy HH:mm')}</b>
              </Typography>

              {statusTrackList?.length !== index + 1 && (
                <Typography variant="body2" color="textSecondary">
                  {renderDuration(status?.startDate, status?.endDate)}
                </Typography>
              )}

              {statusTrackList?.length === index + 1 &&
                status?.endDate !== null && (
                  <Typography variant="body2" color="textSecondary">
                    {renderDuration(
                      statusTrackList?.[0]?.startDate,
                      status?.endDate
                    )}
                  </Typography>
                )}

              {statusTrackList?.length === index + 1 &&
                status?.endDate === null && (
                  <Typography variant="body2" color="textSecondary">
                    {renderCurrentDuration(status?.startDate)}
                  </Typography>
                )}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot color="primary">
                <PersonIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent
              style={{
                padding: '6px 16px 6px 0'
              }}
            >
              <div>
                <Typography variant="body1">
                  {status?.updatedByFullname}
                </Typography>
                <Typography variant="body2" color={'primary'}>
                  {status?.name}
                </Typography>
              </div>
            </TimelineContent>
          </TimelineItem>
        ))
      ) : (
        <Typography variant="h6" style={{ textAlign: 'center' }}>
          Нет активности
        </Typography>
      )}
    </Timeline>
  )
}
const ActivityFeed = ({ open, onClose, id }) => {
  const classes = useStyles()

  const { standardCheck } = useResErrors()
  const [statusTrackList, setStatusTrackList] = useState([])
  const [tabIndex, setTabIndex] = useState(0)

  useEffect(() => {
    if (id && open) {
      getActivity()
    }
  }, [open])

  const getActivity = async () => {
    await SalesService.getAllSaleActivity(id).then(res =>
      standardCheck(
        res,
        () => {
          setStatusTrackList(res.data)
        },
        {
          textErr: 'Ошибка при получении ленты активности'
        }
      )
    )
  }

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex)
  }

  const tabsStatusLine = () => {
    switch (tabIndex) {
      case 0:
        return <StatusLine statusTrackList={statusTrackList?.saleStatusTrack} />
      case 1:
        return (
          <StatusLine statusTrackList={statusTrackList?.carfinStatusTrack} />
        )
      case 2:
        return (
          <StatusLine statusTrackList={statusTrackList?.contractStatusTrack} />
        )
      case 3:
        return <StatusLine statusTrackList={statusTrackList?.dealStatusTrack} />
      default:
        return null
    }
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClick={event => event.stopPropagation()}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <DialogTitleCustom onClose={onClose}>Лента активности</DialogTitleCustom>{' '}
      <Tabs
        className={classes.wlViewTabs}
        value={tabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Cтатус продаж" />
        <Tab label="Статус кредитного брокера" />
        <Tab label="Статус фин. сервис" />
        <Tab label="Статус выкупа авто" />
      </Tabs>
      {tabsStatusLine()}
    </Drawer>
  )
}

export default ActivityFeed
